import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import { artists } from '@/utils/api';
import { MapPin, Package } from 'lucide-react';

const Artists = () => {
  const [artistList, setArtistList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadArtists();
  }, []);

  const loadArtists = async () => {
    try {
      const response = await artists.getAll();
      setArtistList(response.data);
    } catch (error) {
      console.error('Error loading artists:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="artists-page">
      <SEO 
        title="Our Artists"
        description="Meet the talented independent artists on ARTCARDO. Discover painters, sculptors, photographers and craftspeople creating unique handmade artworks."
        keywords="artists, painters, sculptors, Indian artists, contemporary artists, art creators"
        url="/artists"
      />
      <Navbar />
      
      <div style={{paddingTop: "180px"}}>
        <section className="section">
          <h1 className="section-title" data-testid="artists-title">Our Artists & Artisans</h1>
          <p className="section-subtitle" data-testid="artists-subtitle">
            Meet the talented creators behind our beautiful artworks
          </p>

          {loading ? (
            <div className="text-center py-12" data-testid="loading-spinner">
              <p className="text-gray-500">Loading artists...</p>
            </div>
          ) : artistList.length > 0 ? (
            <div className="grid md:grid-cols-3 gap-8" data-testid="artists-grid">
              {artistList.map((artist) => (
                <Link
                  to={`/artists/${artist.id}`}
                  key={artist.id}
                  className="card hover:shadow-xl transition-all duration-300"
                  data-testid={`artist-card-${artist.id}`}
                >
                  <div className="text-center">
                    <div className="w-32 h-32 bg-[#f5f5f5] rounded-full mx-auto mb-4 flex items-center justify-center">
                      <span className="text-4xl text-[#ef4444]">
                        {artist.name.charAt(0).toUpperCase()}
                      </span>
                    </div>
                    <h3 className="text-xl font-semibold mb-2">{artist.name}</h3>
                    {artist.category && (
                      <p className="text-sm text-[#ef4444] font-semibold mb-2">{artist.category}</p>
                    )}
                    {artist.bio && (
                      <p className="text-sm text-gray-600 mb-4 line-clamp-3">{artist.bio}</p>
                    )}
                    <div className="text-sm text-gray-500">
                      <p className="flex items-center justify-center gap-2">
                        <Package className="w-4 h-4" />
                        View Products
                      </p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-12" data-testid="no-artists">
              <p className="text-gray-500 text-lg">No artists found</p>
            </div>
          )}
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Artists;